import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export function isEarlierThanTodayValidator(today: Date): ValidatorFn {
  return (control:AbstractControl) : ValidationErrors | null => {

    if (!control?.value) {
      return null;
    }

    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);

    const value = control?.value.singleDate?.jsDate ? control?.value.singleDate.jsDate : new Date(control.value);

    const isEarlierThanToday = value < today
    return isEarlierThanToday ? {correctDate: true}: null;
  }
}

export function isEarlierThanServicePeriodValidator (date: Date) : ValidatorFn {

  return (control: AbstractControl) : ValidationErrors | null => {

    if (!control?.value) {

      return null;
    }

    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    const isEarlierThan = control?.value.startDate < date || control?.value.endDate < date;
    return isEarlierThan ? { incorrectDate: true } : null;
  }
}

export function startDateBeforeEndDate () : ValidatorFn {

  return (control: AbstractControl) : ValidationErrors | null => {

    if (!control?.value) {

      return null;
    }

    const startAfterEnd = control?.value.startDate > control?.value.endDate;
    return startAfterEnd ? { startAfterEnd: true } : null;
  }
}
